import { Formik, FormikProps } from "formik";
import { useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import AGSelect from "../../../components/AgSelect";
import AGButton from "../../../components/Button";
import AGModal from "../../../components/Modal";
import { useNotification } from "../../../components/Notification";
import { FirmProfile, Individual } from "../../../models";
import { httpGET, httpPUT } from "../../../utils/ajaxHelper";
import { FormContainer } from "./addContact.styled";
import { isEqual, sortBy } from "lodash";

export interface AddServiceModalProps {
    visible: boolean;
    toggleModal: () => void;
    data: FirmProfile;
}
const AddSecondmentContactModal = ({
    visible,
    toggleModal,
    data,
}: AddServiceModalProps) => {
    const { showNotification } = useNotification();

    const handleClose = () => {
        toggleModal();
    };
    const { id } = useParams();
    const [individual, setIndividual] = useState<Individual[]>();
    const formRef = useRef<FormikProps<any>>(null);
    const [isDataChanged,setIsDataChanged] = useState<boolean>(false);
    const { mutate: getIndividuals } = useMutation(
        (id: number) =>
            httpGET({
                url: "/Individuals",
                params: { id },
            }),
        {
            onSuccess: (rs) => {
                setIndividual(rs as Individual[]);
             }, 
        },
    );
    const { mutate: submitForm } = useMutation(
        (data: FormData) =>
            httpPUT({
                url: "/FirmProfile",
                data: data,
            }),
        {
            onSuccess: (rs) => {
                handleClose();
            },
            onError: (rs) => {
                showNotification("Upload Failed", "Error");
            },
        },
    );

    useEffect(() => {
        setIndividual([]);
        getIndividuals(parseInt(id!));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (!data) {
        return null;
    }

    const intitialValues = {
		isUpdateContact: false,
		fkFirmId: data?.fkFirmId,
		logoName: data?.logoName,
		logoPart: data?.logoPart,
		backgroundName: data?.backgroundName,
		backgroundPart: data?.backgroundPart,
		description: data?.description,
		tagLine: data?.tagLine,
		brochureName: data?.brochureName,
		brochurePath: data?.brochurePath,
		videoUrl: data?.videoUrl,
		offerorURL: data!.offerorURL,
        firmSecondmentContactstring: data.individualFirmContacts
        ?.filter((e) =>
            data.firmSecondmentContacts?.map((x) => x.fkIndividualId).includes(e.individualId!),
        )
        ?.sort((a, b) => {
            const firstNameCompare = a.firstName!.localeCompare(b.firstName!);
            if (firstNameCompare !== 0) return firstNameCompare;
            return a.lastName!.localeCompare(b.lastName!);
        })                                    
        .map((e) => ({
            value: e.individualId,
            label: `${e.firstName}  ${e.lastName}`,
        })),
	}

    return (
        <AGModal
            toggleModal={toggleModal}
            title="Secondment Contact"
            footer={
                <>
                    <AGButton
                        type="Primary"
                        onClick={() => {
                            formRef.current?.submitForm();
                        }}
                        disabled={!isDataChanged}>
                        Save
                    </AGButton>
                </>
            }
            visible={visible}
            setHeight={310}>
            <FormContainer className="Form-container">
                {visible && (
                    <Formik
                        innerRef={formRef}
                        initialValues={
                            {
                                isUpdateContact: false,
                                fkFirmId: data?.fkFirmId,
                                logoName: data?.logoName,
                                logoPart: data?.logoPart,
                                backgroundName: data?.backgroundName,
                                backgroundPart: data?.backgroundPart,
                                description: data?.description,
                                tagLine: data?.tagLine,
                                brochureName: data?.brochureName,
                                brochurePath: data?.brochurePath,
                                videoUrl: data?.videoUrl,
                                offerorURL: data!.offerorURL,
                                firmSecondmentContactstring: data.individualFirmContacts
                                    ?.filter((e) =>
                                        data.firmSecondmentContacts?.map((x) => x.fkIndividualId).includes(e.individualId!),
                                    )
                                    ?.sort((a, b) => {
                                        const firstNameCompare = a.firstName!.localeCompare(b.firstName!);
                                        if (firstNameCompare !== 0) return firstNameCompare;
                                        return a.lastName!.localeCompare(b.lastName!);
                                    })                                    
                                    .map((e) => ({
                                        value: e.individualId,
                                        label: `${e.firstName}  ${e.lastName}`,
                                    })),
                                isUpdateSecondmentContact:false
                            } as any
                        }
                        validateOnBlur={false}
                        onSubmit={(values) => {
                            const formData = new FormData();
                            formData.append("fkFirmId", values.fkFirmId);
                            formData.append(
                                "isUpdateSecondmentContact",
                                values.isUpdateSecondmentContact,
                            );
                            formData.append(
                                "description",
                                values.description ? values.description : "",
                            );
                            formData.append(
                                "tagLine",
                                values.tagLine ? values.tagLine : "",
                            );
                            formData.append(
                                "videoUrl",
                                values.videoUrl ? values.videoUrl : "",
                            );
                            formData.append(
                                "offerorURL",
                                values.offerorURL ? values.offerorURL : "",
                            );
                            formData.append(
                                "firmSecondmentContactstring",
                                values.firmSecondmentContactstring !== undefined
                                    ? values.firmSecondmentContactstring
                                            .map(
                                                (x: { value: string }) =>
                                                    x.value,
                                            )
                                            .join(",")
                                    : "",
                            );
                            submitForm(formData);
                        }}>
                        {({ values, errors, setFieldValue }) => {
                            
							const isFirmContactsEqual = isEqual(
								sortBy((intitialValues!.firmSecondmentContactstring as { value: number; label: string }[]).map((x) => x.value)),
								sortBy((values!.firmSecondmentContactstring as { value: number; label: string }[]).map((x) => x.value))
							  );
							  
							setIsDataChanged(isFirmContactsEqual === true ? false : true);
                            return (
                                <form onSubmit={(e) => e.preventDefault()} className="form">
                                    <div className="custom-select">
                                        <label className="label-title-second">
                                            Select a maximum of 3 key contacts. If a key contact for your organization isn’t listed, ask your organization’s AG Champion to get them added to our database.
                                        </label>
                                        <div className="contact-input">
                                            <AGSelect
                                                className="btn"
                                                placeholder="Enter/ Select your answer"
                                                value={values.firmSecondmentContactstring}
                                                onChange={(e: any) => {
                                                    if (e.length > 3) {
                                                        setFieldValue(
                                                            "firmSecondmentContactstring",
                                                            e.slice(1, 4),
                                                        );
                                                    } else {
                                                        setFieldValue(
                                                            "firmSecondmentContactstring",
                                                            e,
                                                        );
                                                    }
                                                    setFieldValue("isUpdateSecondmentContact",true);
                                                }}
                                                options={individual
                                                    ?.sort((a, b) =>
                                                        a.firstName +
                                                            " " +
                                                            a.lastName +
                                                            " - " +
                                                            a.individualEmailAddr >
                                                        b.firstName +
                                                            " " +
                                                            b.lastName +
                                                            " - " +
                                                            b.individualEmailAddr
                                                            ? 1
                                                            : b.firstName +
                                                                    " " +
                                                                    b.lastName +
                                                                    " - " +
                                                                    b.individualEmailAddr >
                                                              a.firstName +
                                                                    " " +
                                                                    a.lastName +
                                                                    " - " +
                                                                    a.individualEmailAddr
                                                            ? -1
                                                            : 0,
                                                    )
                                                    .map((e) => {
                                                        return {
                                                            value: e.individualId,
                                                            label:
                                                                e.firstName +
                                                                " " +
                                                                e.lastName,
                                                        };
                                                    })}
                                                isMulti
                                            />
                                        </div>

                                        {errors.region && (
                                            <div className="error">
                                                This question is required.{" "}
                                            </div>
                                        )}
                                    </div>

                                    {errors.compracticeLevels && (
                                        <div className="error">
                                            This question is required.
                                        </div>
                                    )}
                                </form>
                            );
                        }}
                    </Formik>
                )}
            </FormContainer>
        </AGModal>
    );
};
export default AddSecondmentContactModal;
